import styled from "@emotion/styled";

export const SectionContent = styled.div`
  padding-left: ${({ theme }) => theme.extend.getSpacing(15)};
  padding-top: ${({ theme }) => theme.extend.getSpacing(10)};
  padding-bottom: ${({ theme }) => theme.extend.getSpacing(5)};
`;
